import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * shadcn/ui's class combiner: tailwind-merge drops overridden utilities, so a
 * caller's className wins. Legacy components keep using `classnames`.
 */
export function cn (...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
